import React from "react"
import styled from "styled-components"
import { rem } from "polished"
import { media } from "@sr/common"
import { SanityImg, SemiBdTitle5, RegBodyMed } from "@sr/gatsby-theme-ui"
import SanityImage from "gatsby-plugin-sanity-image"

import QuoteIcon from "../../../images/temp/quote.svg"

export interface CaseStudyEntryQuotePropsShape {
  quote: {
    quoteText: string
    quoteImg: SanityImg
    quoteCitation: string
  }
}

const CaseStudyEntryQuote = ({ quote }: CaseStudyEntryQuotePropsShape) => {
  return (
    <CaseStudyEntryQuoteStyled>
      <img className="quote__quote-icon" src={QuoteIcon} alt="quote icon" />
      <SemiBdTitle5 className="quote__quote">{quote.quoteText}</SemiBdTitle5>
      <div className="quote__author-container">
        {quote?.quoteImg && quote?.quoteImg?.asset ? (
          <SanityImage
            alt={quote?.quoteImg?.alt || ""}
            asset={quote?.quoteImg?.asset}
            className="quote__author-icon"
            crop={quote?.quoteImg?.crop}
            hotspot={quote?.quoteImg?.hotspot}
          />
        ) : null}
        <RegBodyMed className="quote__author">{quote.quoteCitation}</RegBodyMed>
      </div>
    </CaseStudyEntryQuoteStyled>
  )
}

export default CaseStudyEntryQuote

const CaseStudyEntryQuoteStyled = styled.section`
  .quote__quote-icon {
    position: absolute;
    top: ${rem(-32)};
    left: ${rem(-16)};
    fill: var(--color-gray075);
    z-index: 0;

    @media ${media.midUp} {
      top: ${rem(-16)};
      left: ${rem(-32)};
    }

    @media ${media.stMidUp} {
      top: 0;
      left: 0;
    }
  }

  .quote__quote {
    position: relative;

    @media ${media.midUp} {
      font-size: ${rem(24)};
      line-height: ${rem(32)};
    }
  }

  .quote__author-container {
    display: flex;
    flex-direction: column;
    gap: ${rem(8)};
    margin-top: ${rem(16)};

    @media ${media.midUp} {
      flex-direction: row;
    }

    @media ${media.stMidUp} {
      margin-top: ${rem(24)};
    }
  }

  .quote__author-icon {
    height: ${rem(32)};
    width: ${rem(32)};
    border-radius: 50%;
    margin-right: ${rem(16)};
  }
`
